import { Chart as ChartJS, LineElement, BarElement, TimeScale } from "chart.js";
import "chartjs-adapter-date-fns";
import annotationPlugin from "chartjs-plugin-annotation";
import { es } from "date-fns/locale";
import React, { useEffect, useState } from "react";
import { Bar, Line } from "react-chartjs-2";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Col,
  Container,
  FormSelect,
  InputGroup,
  Row,
} from "shards-react";
import {
  getAccuracyByPersonType,
  getAccuracyBySexAndWeight,
  getNumberOfOpinionsByPersonType,
  getBestOpinators,
  getOpinatorNames,
  getOpinions,
  getSemaphore,
  getTotalAccuracy,
  getWorstOpinators,
  getAccuracyByPersonName,
  getAccuracyBySexAndWeightByPerson,
  updateOpinions,
  getOpinatorStatus,
} from "../../../backend/opinions";
import WeeklyDatePicker from "../../common/WeeklyDatePicker";
import moment from "moment";
import { Loading } from "../../common/Loader";
import { parseDate } from "../../../backend/common";
import SmallStats from "../../common/SmallStats2";

ChartJS.register(BarElement, LineElement, TimeScale, annotationPlugin);

const six_months = moment()
  .subtract(6, "months")
  .startOf("isoWeek")
  .format("DD-MM-YYYY");
const three_months = moment()
  .subtract(3, "months")
  .startOf("isoWeek")
  .format("DD-MM-YYYY");
const one_month = moment()
  .subtract(1, "months")
  .startOf("isoWeek")
  .format("DD-MM-YYYY");
const this_week = moment().startOf("isoWeek").format("DD-MM-YYYY");

const Overview = () => {
  // Initialize it as the monday of the last week
  const [selectedDate, setSelectedDate] = useState(this_week);
  const [toDate, setToDate] = useState(null);
  const [loading, setLoading] = useState(true);

  const [totalAccuracy, setTotalAccuracy] = useState("--");
  const [accuracyByPersonType, setAccuracyByPersonType] = useState([]);
  const [bestOpinators, setBestOpinators] = useState([]);
  const [worstOpinators, setWorstOpinators] = useState([]);
  const [totalOpinators, setTotalOpinators] = useState([]);
  const [historicalBestOpinators, setHistoricalBestOpinators] = useState([]);
  const [accuracyBySexAndWeight, setAccuracyBySexAndWeight] = useState([]);
  const [opinatorsNames, setOpinatorsNames] = useState([]);
  const [opinions, setOpinions] = useState([]);
  const [selectedOpinators, setSelectedOpinators] = useState([]);
  const [selectedOpinatorTable, setSelectedOpinatorTable] = useState("");
  const [semaphoreMale, setSemaphoreMale] = useState(undefined);
  const [semaphoreFemale, setSemaphoreFemale] = useState(undefined);
  const [opinionsByPersonType, setOpinionsByPersonType] = useState([]);
  const [accuracyByPersonName, setAccuracyByPersonName] = useState([]);
  const [accuracyBySexAndWeightByPerson, setAccuracyBySexAndWeightByPerson] =
    useState([]);
  const [sort, setSort] = useState({ field: "accuracy", order: "desc" });

  let isOpinionsFetchActive = React.useRef(true);

  const getTotalAccuracy1 = async () => {
    const accuracy = await getTotalAccuracy(selectedDate, toDate);
    setTotalAccuracy(accuracy?.toFixed(1) || "--");
  };

  const getAccuracyByPersonType1 = async () => {
    const accuracy = await getAccuracyByPersonType(selectedDate, toDate);
    setAccuracyByPersonType(accuracy);
  };

  const getBestOpinators1 = async () => {
    let accuracy = await getBestOpinators(selectedDate, toDate, 10);
    accuracy?.forEach((element) => {
      if (element._id.personType === "comercializador") {
        element._id.personType = "C";
      } else if (element._id.personType === "productor") {
        element._id.personType = "P";
      } else {
        element._id.personType = "IA";
      }
    });
    setBestOpinators(accuracy);
  };

  const getWorstOpinators1 = async () => {
    let accuracy = await getWorstOpinators(selectedDate, toDate, 15);
    accuracy?.forEach((element) => {
      if (element._id.personType === "comercializador") {
        element._id.personType = "C";
      } else if (element._id.personType === "productor") {
        element._id.personType = "P";
      } else {
        element._id.personType = "IA";
      }
    });
    setWorstOpinators(accuracy);
  };

  const getTotalOpinators = async () => {
    const response = await getBestOpinators(selectedDate, toDate, null);
    setTotalOpinators(response);
  };

  const getHistoricalBestOpinators = async () => {
    let accuracy = await getBestOpinators(null, null, 10);
    accuracy?.forEach((element) => {
      if (element._id.personType === "comercializador") {
        element._id.personType = "C";
      } else if (element._id.personType === "productor") {
        element._id.personType = "P";
      } else {
        element._id.personType = "IA";
      }
    });
    setHistoricalBestOpinators(accuracy);
  };

  const getAccuracyBySexAndWeight1 = async () => {
    const accuracy = await getAccuracyBySexAndWeight(selectedDate, toDate);
    setAccuracyBySexAndWeight(accuracy);
  };

  const getOpinatorNames1 = async () => {
    const names = await getOpinatorNames();
    setOpinatorsNames(names);
    setSelectedOpinators(names?.slice(0, 1));
  };

  const getOpinions1 = async () => {
    const opinions = await getOpinions(selectedDate, toDate, selectedOpinators);
    setOpinions(opinions);
  };

  const getSemaphore1 = async () => {
    const semaphore = await getSemaphore(selectedDate, toDate);
    // Filter by male and female
    setSemaphoreMale(semaphore?.find((data) => data._id.sex === "male"));
    setSemaphoreFemale(semaphore?.find((data) => data._id.sex === "female"));
  };

  const getNumberOfOpinionsByPersonType1 = async () => {
    const response = await getNumberOfOpinionsByPersonType(
      selectedDate,
      toDate
    );
    setOpinionsByPersonType(response);
  };

  const getAccuracyByPersonName1 = async () => {
    const response = await getAccuracyByPersonName(
      selectedDate,
      toDate,
      selectedOpinators
    );
    setAccuracyByPersonName(response);
  };

  const getAccuracyBySexAndWeightByPerson1 = async () => {
    const response = await getAccuracyBySexAndWeightByPerson(
      selectedDate,
      toDate,
      selectedOpinators
    );
    setAccuracyBySexAndWeightByPerson(response);
  };

  const handleSort = (field) => {
    setSort({ field, order: sort.order === "asc" ? "desc" : "asc" });
  };

  const sortData = (data) => {
    return data?.sort((a, b) => {
      if (sort?.order === "asc") {
        return a[sort.field] - b[sort.field];
      } else {
        return b[sort.field] - a[sort.field];
      }
    });
  };

  const fetchOpinionsStatus = async () => {
    setLoading(true);
    while (isOpinionsFetchActive.current) {
      const { status } = await getOpinatorStatus();
      if (!status || status !== "running") {
        break;
      } else {
        setLoading(true);
      }
      // Sleep for 5 seconds
      await new Promise((resolve) => setTimeout(resolve, 5000));
    }
    // Fetch the data again
    getTotalAccuracy1();
    getAccuracyByPersonType1();
    getBestOpinators1();
    getWorstOpinators1();
    getAccuracyBySexAndWeight1();
    getOpinatorNames1();
    getSemaphore1();
    getNumberOfOpinionsByPersonType1();
    getHistoricalBestOpinators();
    getTotalOpinators();
    isOpinionsFetchActive.current = false;
    setLoading(false);
  };

  const updateOpinions1 = async (date) => {
    setLoading(true);
    const response = await updateOpinions(date);
    if (!response) {
      setLoading(false);
      return;
    }
    isOpinionsFetchActive.current = true;
    fetchOpinionsStatus();
  };

  useEffect(() => {
    isOpinionsFetchActive.current = true;
    fetchOpinionsStatus();
    return () => {
      isOpinionsFetchActive.current = false;
    };
  }, [selectedDate]);

  useEffect(() => {
    getOpinions1();
    getAccuracyByPersonName1();
  }, [selectedOpinators]);

  useEffect(() => {
    getAccuracyBySexAndWeightByPerson1();
  }, [selectedOpinators]);

  return (
    <Container
      fluid
      className="p-4"
      style={{
        minHeight: "90vh",
        overflow: "hidden",
        maxWidth: 1600,
      }}
    >
      <Row
        className="mb-3"
        style={{
          paddingLeft: 10,
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          columnGap: 30,
          rowGap: 10,
        }}
      >
        <h3 className="m-0" style={{ alignSelf: "end" }}>
          Opiniones
        </h3>
        <div>
          <label style={{ display: "block", margin: 0 }}>Acumulado</label>
          <ButtonGroup style={{ flexWrap: "wrap", marginRight: 10 }}>
            <Button
              onClick={() => {
                setSelectedDate(six_months);
                setToDate(null);
              }}
              outline={selectedDate !== six_months}
              disabled={loading}
            >
              6 meses
            </Button>
            <Button
              onClick={() => {
                setSelectedDate(three_months);
                setToDate(null);
              }}
              outline={selectedDate !== three_months}
              disabled={loading}
            >
              3 meses
            </Button>
            <Button
              onClick={() => {
                setSelectedDate(one_month);
                setToDate(null);
              }}
              outline={selectedDate !== one_month}
              disabled={loading}
            >
              1 mes
            </Button>
            <Button
              onClick={() => {
                setSelectedDate(this_week);
                setToDate(null);
              }}
              outline={selectedDate !== this_week}
              disabled={loading}
            >
              Esta semana
            </Button>
          </ButtonGroup>
        </div>
        <div>
          <label style={{ display: "block", margin: 0 }}>Semana concreta</label>
          <WeeklyDatePicker
            date={moment(selectedDate, "DD-MM-YYYY")}
            changeDate={(newDate) => {
              setSelectedDate(newDate.startOf("isoWeek").format("DD-MM-YYYY"));
              setToDate(newDate.endOf("isoWeek").format("DD-MM-YYYY"));
            }}
            loading={loading}
          />
        </div>
        <div style={{ marginTop: 19, marginLeft: "auto", marginRight: 15 }}>
          <Button
            onClick={() => updateOpinions1(selectedDate)}
            disabled={loading}
          >
            {loading ? "Actualizando opiniones..." : "Actualizar opiniones"}
          </Button>
        </div>
      </Row>
      <Alert
        fade
        style={{ backgroundColor: "#dddddd", color: "black", marginTop: 10 }}
      >
        La <span style={{ color: "#046ecb" }}>PRECISIÓN</span> mostrada se
        calcula con la diferencia del valor absoluto entre la opinión y el
        precio real.
      </Alert>
      {/* <SumUp /> */}
      <div className="dashboard-analysis-complete-grid">
        <Card
          style={{
            boxShadow: "0 0 10px 0 rgba(100,110,140,.2)",
            padding: "10px 40px",
            gridArea: "total",
            overflow: "hidden",
          }}
        >
          <Row
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div>
              <h4>
                Precisión{" "}
                <span style={{ fontWeight: "bold", fontSize: 17 }}>
                  ({"< 0.03"})
                </span>
              </h4>
              Media total: <h2>{totalAccuracy}%</h2>
            </div>
            <Col
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                overflow: "auto",
                minWidth: 200,
              }}
            >
              <table
                className="table-mid mb-0"
                style={{ margin: "0 auto", fontSize: 17 }}
              >
                <thead className="bg-light">
                  <tr>
                    <th scope="col" className="border-0"></th>
                    <th scope="col" className="border-0">
                      Macho
                    </th>
                    <th scope="col" className="border-0"></th>
                    <th scope="col" className="border-0">
                      Hembra
                    </th>
                    <th scope="col" className="border-0"></th>
                    <th scope="col" className="border-0">
                      Frisón
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{"<280KG"}</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === "<280KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                    <td>180/220KG</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === "180/220KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                    <td>{"<220KG"}</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === "<220KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                  </tr>
                  <tr>
                    <td>281/320KG</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === "281/320KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                    <td>221/260KG</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === "221/260KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                    <td>{">220KG"}</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === ">220KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                  </tr>
                  <tr>
                    <td>321/370KG</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === "321/370KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                    <td>261/300KG</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === "261/300KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                  </tr>
                  <tr>
                    <td>{">371KG"}</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === ">371KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                    <td>{">300KG"}</td>
                    <td>
                      {accuracyBySexAndWeight?.find(
                        (row) => row._id.weight === ">300KG"
                      )?.accuracy ?? "-"}
                      %
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <div
              style={{
                height: "100%",
                maxHeight: 200,
                width: "100%",
                maxWidth: 250,
                margin: "0 auto",
              }}
            >
              <Bar
                data={{
                  labels: ["Com.", "Prod.", "IA"],
                  datasets: [
                    {
                      backgroundColor: [
                        "rgba(75,192,192,0.7)",
                        "rgba(255,99,132,0.7)",
                        "rgba(255,206,86,0.7)",
                      ],
                      borderWidth: 1,
                      hoverBackgroundColor: [
                        "rgba(75,192,192,0.6)",
                        "rgba(255,206,86,0.6)",
                        "rgba(255,99,132,0.6)",
                      ],
                      hoverBorderColor: "rgba(75,192,192,1)",
                      maxBarThickness: 50,
                      data: [
                        accuracyByPersonType
                          ?.find(
                            (person) =>
                              person._id.personType === "comercializador"
                          )
                          ?.accuracy?.toFixed(1) || 0,
                        accuracyByPersonType
                          ?.find(
                            (person) => person._id.personType === "productor"
                          )
                          ?.accuracy?.toFixed(1) || 0,
                        accuracyByPersonType
                          ?.find((person) => person._id.personType === "IA")
                          ?.accuracy?.toFixed(1) || 0,
                      ],
                    },
                  ],
                }}
                options={{
                  plugins: {
                    annotation: {
                      annotations: {
                        line: {
                          type: "line",
                          yMin: totalAccuracy,
                          yMax: totalAccuracy,
                          borderColor: "grey",
                          borderWidth: 1,
                          borderDash: [5, 3],
                        },
                      },
                    },
                    title: {
                      display: true,
                      text: "Precisión media",
                      font: {
                        size: 16,
                      },
                    },
                    legend: {
                      display: false,
                    },
                    datalabels: {
                      font: {
                        size: 14,
                        weight: "bold",
                      },
                    },
                  },
                  scales: {
                    x: {
                      grid: {
                        display: false,
                      },
                      ticks: {
                        font: {
                          size: 14,
                        },
                      },
                    },
                    y: {
                      display: false,
                      grid: {
                        display: false,
                      },
                      ticks: {
                        font: {
                          size: 14,
                        },
                      },
                    },
                  },
                  maintainAspectRatio: false,
                }}
              />
            </div>
          </Row>
        </Card>
        <Card
          className="p-4"
          style={{
            boxShadow: "0 0 10px 0 rgba(100,110,140,.2)",
            gridArea: "hits",
          }}
        >
          <Row>
            <Col>
              <h4 className="mb-0">Mejores opinadores</h4>
              <div style={{ overflow: "auto" }}>
                <table className="mb-0 mt-2" style={{ margin: "0 auto" }}>
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0"></th>
                      <th scope="col" className="border-0">
                        Nombre
                      </th>
                      <th scope="col" className="border-0">
                        Prec.
                      </th>
                      <th scope="col" className="border-0">
                        Opiniones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {bestOpinators?.map((person, idx) => (
                      <tr
                        key={idx}
                        style={{
                          fontWeight: idx < 3 ? "bold" : "normal",
                          backgroundColor:
                            person._id.personType === "IA"
                              ? "rgba(255,206,86,0.4)"
                              : "white",
                        }}
                      >
                        <td> {idx + 1}. </td>
                        <td>
                          {person._id.personName +
                            " (" +
                            person._id.personType +
                            ")"}
                        </td>
                        <td>{person.accuracy}%</td>
                        <td style={{ textAlign: "right" }}>
                          {person.numOpinions}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </Card>
        <Card
          className="p-2"
          style={{
            boxShadow: "0 0 10px 0 rgba(100,110,140,.2)",
            gridArea: "semaphore",
          }}
        >
          {/* <h4>Semáforo</h4> */}
          <div style={{ height: 200 }}>
            <Bar
              data={{
                labels: [
                  "E3",
                  "U3",
                  "R3",
                  "O3",
                  "E3",
                  "U3",
                  "R3",
                  "O3",
                  "E3",
                  "U3",
                  "R3",
                  "O3",
                  "E3",
                  "U3",
                  "R3",
                  "O3",
                  "O3=",
                  "O3=",
                ],
                datasets: [
                  {
                    backgroundColor: "#F9360B",
                    data: semaphoreMale?.data?.map((data, index) => {
                      const total =
                        data.countLessThanMinus3 +
                        data.countBetweenMinus3And3 +
                        data.countGreaterThan3;
                      return total > 0
                        ? Math.round((data.countLessThanMinus3 / total) * 100)
                        : 0;
                    }),
                  },
                  {
                    backgroundColor: "#FFF033",
                    data: semaphoreMale?.data?.map((data, index) => {
                      const total =
                        data.countLessThanMinus3 +
                        data.countBetweenMinus3And3 +
                        data.countGreaterThan3;
                      return total > 0
                        ? Math.round(
                            (data.countBetweenMinus3And3 / total) * 100
                          )
                        : 0;
                    }),
                  },
                  {
                    backgroundColor: "#3ACA00",
                    data: semaphoreMale?.data?.map((data, index) => {
                      const total =
                        data.countLessThanMinus3 +
                        data.countBetweenMinus3And3 +
                        data.countGreaterThan3;
                      return total > 0
                        ? Math.round((data.countGreaterThan3 / total) * 100)
                        : 0;
                    }),
                  },
                ],
              }}
              options={{
                maintainAspectRatio: false,
                // Remove barThickness and use these spacing options instead
                categoryPercentage: 0.8, // Controls the space between categories (bars)
                barPercentage: 1.0, // Controls the width of bars within a category
                maxBarThickness: 30,

                plugins: {
                  title: {
                    display: true,
                    text: "Machos",
                    font: {
                      size: 16,
                    },
                  },
                  legend: {
                    display: false,
                  },
                  datalabels: {
                    display: false,
                  },
                  tooltip: {
                    mode: "index", // Show tooltip for all datasets at the same x-axis position
                    intersect: false,
                    callbacks: {
                      label: function (context) {
                        return context.parsed.y + "%";
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    stacked: true,
                    grid: {
                      display: false,
                    },
                    ticks: {
                      font: {
                        size: 14,
                      },
                    },
                  },
                  secondX: {
                    axis: "x",
                    labels: [
                      "<280KG",
                      "281/320KG",
                      "321/370KG",
                      ">371KG",
                      "<220KG    >220KG",
                    ],
                    grid: {
                      display: false,
                    },
                    ticks: {
                      font: {
                        size: 14,
                      },
                    },
                  },
                  y: {
                    display: false,
                    stacked: true,
                    ticks: {
                      min: 0,
                      max: 100,
                      callback: function (value) {
                        return value + "%";
                      },
                      font: {
                        size: 14,
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                },
              }}
            />
          </div>
          <div style={{ height: 190, width: "89%" }}>
            <Bar
              data={{
                labels: [
                  "E3",
                  "U3",
                  "R3",
                  "O3",
                  "E3",
                  "U3",
                  "R3",
                  "O3",
                  "E3",
                  "U3",
                  "R3",
                  "O3",
                  "E3",
                  "U3",
                  "R3",
                  "O3",
                ],
                responsive: true,
                datasets: [
                  {
                    backgroundColor: "#F9360B",
                    data: semaphoreFemale?.data?.map((data) => {
                      const total =
                        data.countLessThanMinus3 +
                        data.countBetweenMinus3And3 +
                        data.countGreaterThan3;
                      return total > 0
                        ? Math.round((data.countLessThanMinus3 / total) * 100)
                        : 0;
                    }),
                  },
                  {
                    backgroundColor: "#FFF033",
                    data: semaphoreFemale?.data?.map((data) => {
                      const total =
                        data.countLessThanMinus3 +
                        data.countBetweenMinus3And3 +
                        data.countGreaterThan3;
                      return total > 0
                        ? Math.round(
                            (data.countBetweenMinus3And3 / total) * 100
                          )
                        : 0;
                    }),
                  },
                  {
                    backgroundColor: "#3ACA00",
                    data: semaphoreFemale?.data?.map((data) => {
                      const total =
                        data.countLessThanMinus3 +
                        data.countBetweenMinus3And3 +
                        data.countGreaterThan3;
                      return total > 0
                        ? Math.round((data.countGreaterThan3 / total) * 100)
                        : 0;
                    }),
                  },
                ],
              }}
              options={{
                maintainAspectRatio: false,
                categoryPercentage: 0.8, // Controls the space between categories (bars)
                barPercentage: 1.0, // Controls the width of bars within a category
                maxBarThickness: 30,
                plugins: {
                  title: {
                    display: true,
                    text: "Hembras",
                    font: {
                      size: 15,
                    },
                  },
                  legend: {
                    display: false,
                  },
                  datalabels: {
                    display: false,
                  },
                  tooltip: {
                    mode: "index", // Show tooltip for all datasets at the same x-axis position
                    intersect: false,
                    callbacks: {
                      label: function (context) {
                        return context.parsed.y + "%";
                      },
                    },
                  },
                },
                scales: {
                  x: {
                    stacked: true,
                    grid: {
                      display: false,
                    },
                    ticks: {
                      font: {
                        size: 14,
                      },
                    },
                  },
                  secondX: {
                    axis: "x",
                    labels: ["180/220KG", "221/260KG", "261/300KG", ">300KG"],
                    grid: {
                      display: false,
                    },
                    ticks: {
                      font: {
                        size: 14,
                      },
                    },
                  },
                  y: {
                    display: false,
                    stacked: true,
                    ticks: {
                      min: 0,
                      max: 100,
                      callback: function (value) {
                        return value + "%";
                      },
                      font: {
                        size: 14,
                      },
                    },
                    grid: {
                      display: false,
                    },
                  },
                },
              }}
            />
          </div>
        </Card>
        <Card
          className="p-4"
          style={{
            boxShadow: "0 0 10px 0 rgba(100,110,140,.2)",
            gridArea: "misses",
          }}
        >
          <Row>
            <Col>
              <h4 className="mb-0">Peores opinadores</h4>
              <div style={{ overflow: "auto" }}>
                <table className="mb-0 mt-2" style={{ margin: "0 auto" }}>
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0"></th>
                      <th scope="col" className="border-0">
                        Nombre
                      </th>
                      <th scope="col" className="border-0">
                        Prec.
                      </th>
                      <th scope="col" className="border-0">
                        Opiniones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {worstOpinators?.map((person, idx) => (
                      <tr
                        key={idx}
                        style={{
                          fontWeight: idx < 3 ? "bold" : "normal",
                          backgroundColor:
                            person._id.personType === "IA"
                              ? "rgba(255,206,86,0.4)"
                              : "white",
                        }}
                      >
                        <td> {idx + 1}. </td>
                        <td>
                          {person._id.personName +
                            " (" +
                            person._id.personType +
                            ")"}
                        </td>
                        <td>{person.accuracy}%</td>
                        <td style={{ textAlign: "right" }}>
                          {person.numOpinions}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </Card>
        <Card
          className="p-4"
          style={{
            boxShadow: "0 0 10px 0 rgba(100,110,140,.2)",
            gridArea: "histogram",
          }}
        >
          <div style={{ height: "100%", minHeight: 250, maxHeight: 500 }}>
            <Bar
              data={{
                labels: [
                  -10, -9, -8, -7, -6, -5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5, 6,
                  7, 8, 9, 10,
                ],
                datasets: [
                  {
                    label: "Comercializadores",
                    backgroundColor: "rgba(75,192,192,0.7)",
                    borderColor: "rgba(75,192,192,1)",
                    borderWidth: 1,
                    hoverBackgroundColor: "rgba(75,192,192,0.9)",
                    hoverBorderColor: "rgba(75,192,192,1)",
                    data: opinionsByPersonType
                      ?.find((person) => person._id === "comercializador")
                      ?.variations?.map((variation) => {
                        return {
                          x: variation.variation,
                          y: variation.numOpinions,
                        };
                      }),
                  },
                  {
                    label: "Productores",
                    backgroundColor: "rgba(255,99,132,0.7)",
                    borderColor: "rgba(255,99,132,1)",
                    borderWidth: 1,
                    hoverBackgroundColor: "rgba(255,99,132,0.9)",
                    hoverBorderColor: "rgba(255,99,132,1)",
                    data: opinionsByPersonType
                      ?.find((person) => person._id === "productor")
                      ?.variations?.map((variation) => {
                        return {
                          x: variation.variation,
                          y: variation.numOpinions,
                        };
                      }),
                  },
                ],
              }}
              options={{
                maintainAspectRatio: false,
                plugins: {
                  legend: {
                    labels: {
                      font: {
                        size: 14,
                      },
                    },
                  },
                  datalabels: {
                    display: false,
                  },
                },
                scales: {
                  x: {
                    stacked: false,
                    grid: {
                      display: false,
                    },
                    ticks: {
                      font: {
                        size: 14,
                      },
                    },
                  },
                  y: {
                    stacked: false,
                    display: false,
                    grid: {
                      display: false,
                    },
                    ticks: {
                      font: {
                        size: 14,
                      },
                    },
                  },
                },
              }}
            />
          </div>
        </Card>
        <Card
          className="p-4"
          style={{
            boxShadow: "0 0 10px 0 rgba(100,110,140,.2)",
            gridArea: "hits-history",
          }}
        >
          <h5>Historial de mejores opinadores</h5>
          <div style={{ overflow: "auto" }}>
            <table className="mb-0 mt-2" style={{ margin: "0 auto" }}>
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0"></th>
                  <th scope="col" className="border-0">
                    Nombre
                  </th>
                  <th scope="col" className="border-0">
                    Prec.
                  </th>
                  <th scope="col" className="border-0">
                    Opiniones
                  </th>
                </tr>
              </thead>
              <tbody>
                {historicalBestOpinators?.map((person, idx) => (
                  <tr
                    key={idx}
                    style={{
                      fontWeight: idx < 3 ? "bold" : "normal",
                      backgroundColor:
                        person._id.personType === "IA"
                          ? "rgba(255,206,86,0.4)"
                          : "white",
                    }}
                  >
                    <td> {idx + 1}. </td>
                    <td>
                      {person._id.personName +
                        " (" +
                        person._id.personType +
                        ")"}
                    </td>
                    <td>{person.accuracy}%</td>
                    <td style={{ textAlign: "right" }}>{person.numOpinions}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
        <Card
          className="p-4"
          style={{
            boxShadow: "0 0 10px 0 rgba(100,110,140,.2)",
            gridArea: "person",
          }}
        >
          <Row style={{ flexWrap: "wrap" }}>
            <Col>
              <h5>Comparación de opinadores</h5>
            </Col>
            <Col>
              <InputGroup
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "start",
                  minWidth: 200,
                  gap: 10,
                }}
              >
                <FormSelect
                  className="mb-2"
                  // multiple
                  onChange={(e) => {
                    setSelectedOpinators(
                      [...e.target.selectedOptions].map(
                        (option) => option.value
                      )
                    );
                  }}
                >
                  {opinatorsNames?.map((person, idx) => (
                    <option key={idx}>{person}</option>
                  ))}
                </FormSelect>
              </InputGroup>
            </Col>
          </Row>
          <Row>
            <Col
              sm="12"
              md="7"
              className="mb-3 mb-md-0"
              style={{ minWidth: 200, minHeight: 400 }}
            >
              <Line
                data={{
                  datasets: [
                    ...(opinions?.map((opinion, idx) => ({
                      label: opinion._id,
                      lineTension: 0.1,
                      borderColor: `rgba(${(idx * 20) % 255}, ${
                        (idx * 140) % 255
                      }, ${(idx * 150) % 255}, 1)`, // Random color
                      // Random color regarding the index
                      pointRadius: 3,
                      pointHitRadius: 20,
                      data: opinion.data
                        ?.map((data) => {
                          return {
                            x: parseDate(new Date(data.dateStandard)),
                            y: data.opinion,
                          };
                        })
                        ?.sort((a, b) => a.x - b.x),
                    })) || []),
                    {
                      label: "Real Binéfar",
                      fill: false,
                      lineTension: 0.1,
                      backgroundColor: "rgba(255,180,0,0.4)",
                      borderColor: "rgba(255,180,0)",
                      borderCapStyle: "butt",
                      borderDash: [],
                      pointRadius: 3,
                      pointHitRadius: 10,
                      data: opinions
                        ?.map((opinion) =>
                          opinion?.data?.map((data) => {
                            return {
                              x: parseDate(new Date(data.dateStandard)),
                              y: data.realPrice,
                            };
                          })
                        )
                        ?.flat()
                        ?.sort((a, b) => a.x - b.x),
                    },
                    {
                      label: "Predicción",
                      fill: false,
                      lineTension: 0.1,
                      backgroundColor: "rgba(255,65,105,0.4)",
                      borderColor: "rgba(255,65,105,1)",
                      borderCapStyle: "butt",
                      borderDash: [],
                      pointRadius: 3,
                      pointHitRadius: 10,
                      data: opinions
                        ?.map((opinion) =>
                          opinion?.data?.map((data) => {
                            return {
                              x: parseDate(new Date(data.dateStandard)),
                              y: data.iaPrediction,
                            };
                          })
                        )
                        ?.flat()
                        ?.sort((a, b) => a.x - b.x),
                    },
                  ],
                }}
                options={{
                  maintainAspectRatio: false,
                  interaction: {
                    mode: "index",
                    intersect: false,
                    position: "bottom",
                  },
                  responsive: true,
                  elements: {
                    line: {
                      tension: 0.3,
                      spanGaps: false,
                      fill: false,
                      borderWidth: 2,
                    },
                  },
                  scales: {
                    y: {
                      type: "linear",
                      display: true,
                      offset: true,
                    },
                    y: {
                      gridLines: {
                        display: true,
                        color: "rgba(102,102,102,0.48)",
                      },
                      ticks: {
                        padding: 20,
                      },
                      offset: true,
                      stacked: false,
                    },
                  },
                  plugins: {
                    title: {
                      display: true,
                      text: "Precios opinadores vs real (promedio)",
                      font: {
                        size: 18,
                      },
                    },
                    datalabels: {
                      display: false,
                    },
                  },
                }}
              />
            </Col>
            <Col sm="12" md="5">
              <div style={{ minHeight: 200 }}>
                <Bar
                  data={{
                    labels: accuracyByPersonName?.map(
                      (person) =>
                        person._id.personName + " (" + person.numOpinions + ")"
                    ),
                    datasets: [
                      {
                        label: "Precisión",
                        backgroundColor: "rgba(75,192,192,0.4)",
                        borderColor: "rgba(75,192,192,1)",
                        borderWidth: 1,
                        hoverBackgroundColor: "rgba(75,192,192,0.6)",
                        hoverBorderColor: "rgba(75,192,192,1)",
                        maxBarThickness: 50,
                        data: accuracyByPersonName?.map(
                          (person) => person.accuracy
                        ),
                      },
                    ],
                  }}
                  options={{
                    plugins: {
                      legend: {
                        display: false,
                      },
                      datalabels: {
                        formatter: function (value, context) {
                          return value.y;
                        },
                        font: {
                          size: 15,
                        },
                      },
                    },
                    indexAxis: "y",
                    maintainAspectRatio: false,
                    scales: {
                      x: {
                        display: false,
                        reverse: true,
                        grid: {
                          display: false,
                        },
                        min: 0,
                        max: 100,
                      },
                      y: {
                        position: "right",
                        grid: {
                          display: false,
                        },
                      },
                    },
                  }}
                />
              </div>
              <div style={{ overflowX: "auto" }}>
                <table
                  className="table-mid mb-0"
                  style={{ margin: "0 auto", minWidth: 300, fontSize: 17 }}
                >
                  <thead className="bg-light">
                    <tr>
                      <th scope="col" className="border-0"></th>
                      <th scope="col" className="border-0">
                        Macho
                      </th>
                      <th scope="col" className="border-0"></th>
                      <th scope="col" className="border-0">
                        Hembra
                      </th>
                      <th scope="col" className="border-0"></th>
                      <th scope="col" className="border-0">
                        Frisón
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{"<280KG"}</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === "<280KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                      <td>180/220KG</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === "180/220KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                      <td>{"<220KG"}</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === "<220KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                    </tr>
                    <tr>
                      <td>281/320KG</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === "281/320KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                      <td>221/260KG</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === "221/260KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                      <td>{">220KG"}</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === ">220KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                    </tr>
                    <tr>
                      <td>321/370KG</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === "321/370KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                      <td>261/300KG</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === "261/300KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                    </tr>
                    <tr>
                      <td>{">371KG"}</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === ">371KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                      <td>{">300KG"}</td>
                      <td>
                        {accuracyBySexAndWeightByPerson?.find(
                          (row) => row._id.weight === ">300KG"
                        )?.accuracy ?? "-"}
                        %
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </Card>
        <Card
          className="p-4"
          style={{
            boxShadow: "0 0 10px 0 rgba(100,110,140,.2)",
            gridArea: "opinators-total",
          }}
        >
          <h5>Tabla completa opinadores</h5>
          <div style={{ overflowX: "auto" }}>
            <table className="table mb-0" style={{ margin: "0 auto" }}>
              <thead className="bg-light">
                <tr>
                  <th scope="col" className="border-0"></th>
                  <th scope="col" className="border-0">
                    Nombre
                  </th>
                  <th scope="col" className="border-0">
                    Tipo
                  </th>
                  <th
                    style={{ cursor: "pointer", maxWidth: 70 }}
                    onClick={() => handleSort("accuracy")}
                    scope="col"
                    className="border-0"
                  >
                    {`Precisión (<0.03)`}{" "}
                    <i className="material-icons">swap_vert</i>
                  </th>
                  <th
                    style={{ cursor: "pointer", maxWidth: 70 }}
                    onClick={() => handleSort("numOpinions")}
                    scope="col"
                    className="border-0"
                  >
                    Num. opiniones <i className="material-icons">swap_vert</i>
                  </th>
                </tr>
              </thead>
              <tbody>
                {sortData(totalOpinators)?.map((person, idx) => (
                  <tr
                    class="item"
                    key={idx}
                    style={{
                      backgroundColor:
                        person._id.personType === "IA"
                          ? "rgba(255,206,86,0.4)"
                          : "white",
                    }}
                  >
                    <td className="p-1"> {idx + 1}. </td>
                    <td className="p-1">{person._id.personName}</td>
                    <td className="p-1">{person._id.personType}</td>
                    <td className="p-1">{person.accuracy}%</td>
                    <td className="p-1">{person.numOpinions}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Card>
      </div>
    </Container>
  );
};

export default Overview;
